var addImages, doTheDropdown;

addImages = function() {
  var selector;
  selector = '.js-add-image';
  if ($(selector).length) {
    return $.each($(selector), function() {
      var payload;
      payload = {
        serviceId: $(this).data('serviceid')
      };
      payload[csrfTokenName] = csrfTokenValue;
      return $(this).load(siteUrl + '_partials/components/_dropdownServiceImage', payload);
    });
  }
};

doTheDropdown = function() {
  var $allSubNavigations, $dropdown, closeDropdown, dropdownShouldClose, dropdownStaysOpen, openClass, openDropdown, openTimer, selector, timeout;
  selector = '.services-dropdown-toggle';
  if ($(selector).length) {
    openTimer = void 0;
    timeout = 750;
    openClass = 'open';
    $dropdown = $('.services-dropdown');
    $allSubNavigations = $('.services-navigation');
    closeDropdown = function() {
      return $dropdown.removeClass(openClass);
    };
    openDropdown = function($target) {
      $allSubNavigations.removeClass(openClass);
      $target.addClass(openClass);
      return $dropdown.addClass(openClass);
    };
    dropdownStaysOpen = function() {
      return clearTimeout(openTimer);
    };
    dropdownShouldClose = function() {
      openTimer = setTimeout((function() {
        return closeDropdown();
      }), timeout);
    };
    $(selector).mouseenter(function() {
      openDropdown($('#' + $(this).data('servicedropdown')));
      return dropdownStaysOpen();
    });
    $(document).on('click', function() {
      return closeDropdown();
    });
    $(selector).mouseleave(function() {
      return dropdownShouldClose();
    });
    $dropdown.mouseenter(function() {
      return dropdownStaysOpen();
    });
    return $dropdown.mouseleave(function() {
      return dropdownShouldClose();
    });
  }
};

$(function() {
  addImages();
  return doTheDropdown();
});

// ---
// generated by coffee-script 1.9.2